import ApiService from "../../../ApiService";

const EditDialogService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/talkchinese/editdialog/loadscreenview", { id }, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/talkchinese/editdialog/save", vo, successCallback, failureCallback);
    }
};

export default EditDialogService;